/* eslint-disable */
import "./style.sass";
import countries from "./countries";
window.DatoCmsPlugin.init((plugin) => {
  plugin.startAutoResizer();

  const container = document.createElement("select");
  container.classList.add("container");
  container.textContent = "Hello, world!";

  for (const country of countries) {
    const option = document.createElement("option");
    option.value = country.alpha3Code;
    option.innerText = country.name;
    container.appendChild(option);
  }

  let activeCountry = plugin.getFieldValue(plugin.fieldPath);

  activeCountry = JSON.parse(activeCountry) || false;

  if (activeCountry?.alpha3Code) {
    container.value = activeCountry.alpha3Code;
  }
  container.addEventListener("change", ($event) => {
    const country = countries.find(
      (item) => item.alpha3Code === $event.target.value
    );
    plugin.setFieldValue(plugin.fieldPath, JSON.stringify(country));
  });

  document.body.appendChild(container);
});
